var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDateAdded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_23847",
    "data-name": "Group 23847",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.862,
    height: 17.843,
    viewBox: "0 0 18.862 17.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-icon-date-added"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4491",
    "data-name": "Rectangle 4491",
    width: 18.862,
    height: 17.843,
    fill: "#343d63"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23846",
    "data-name": "Group 23846",
    clipPath: "url(#clip-path-icon-date-added)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22962",
    "data-name": "Path 22962",
    d: "M0,27.86a.991.991,0,0,1,.991-.991H9.418a.5.5,0,0,1,0,.991H.991v14.87H17.844V34.3a.5.5,0,1,1,.991,0v8.426a.991.991,0,0,1-.991.991H.991A.991.991,0,0,1,0,42.731Z",
    transform: "translate(0 -25.879)",
    fill: "#343d63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22963",
    "data-name": "Path 22963",
    d: "M208.591.993a.945.945,0,0,0-.738.316L200.26,8.9l-.234,1.636,1.636-.234,7.594-7.594a.946.946,0,0,0,.316-.738,1.047,1.047,0,0,0-.316-.664,1.046,1.046,0,0,0-.664-.316m1.97.922a1.933,1.933,0,0,1-.6,1.5l-7.6,7.6a.984.984,0,0,1-.559.279l-1.636.234a.991.991,0,0,1-1.122-1.121l.234-1.636a.991.991,0,0,1,.28-.561L207.152.608a1.933,1.933,0,0,1,1.5-.6,2.035,2.035,0,0,1,1.307.6A2.034,2.034,0,0,1,210.561,1.915Z",
    transform: "translate(-191.702 0)",
    fill: "#343d63",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateAdded);
export default __webpack_public_path__ + "static/media/icon-date-added.94eaddee747e1f982f91cdbe10b3d845.svg";
export { ForwardRef as ReactComponent };